import { useEffect } from "react";
import { returnMsUntilNextLocalMidnight } from "@/lib/businessRules/settlementDateRules";
import { rollAllStaleTradeDates } from "@/store/tradeFromScratchStoreACTIONS";

// LQC-2981 - roll open tickets' trade dates at local midnight, so the screen shows today
// before anyone sends. Background tabs throttle timers and sleep pauses them, so a tab
// becoming visible checks too. The send-time roll stays as the backstop.

// Fire just after midnight, never on the last tick of the old day.
export const MIDNIGHT_BUFFER_MS = 1000;

export function useTradeDateRollover(isEnabled = true): void {
  useEffect(() => {
    if (!isEnabled) return;
    let timer: ReturnType<typeof setTimeout>;

    const scheduleNextMidnight = () => {
      timer = setTimeout(() => {
        rollAllStaleTradeDates();
        scheduleNextMidnight();
      }, returnMsUntilNextLocalMidnight() + MIDNIGHT_BUFFER_MS);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") rollAllStaleTradeDates();
    };

    rollAllStaleTradeDates();
    scheduleNextMidnight();
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isEnabled]);
}
